<div class="d-flex justify-content-center align-items-center background" style="padding-top: 100px; padding-bottom: 400px;">
  
  <div *ngIf="!user" class="d-flex justify-content-center align-items-center" style="height: 200px;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  
  <div *ngIf="user" class="card mt-4">
    <div class="card-header">
      <h2>Uporabniški podatki</h2>
    </div>
    <div class="card-body">
      <!-- Display User Information -->
      <div *ngIf="!isUserEditMode">
        <p><strong>Uporabniško ime:</strong> {{ user.username }}</p>
        <p><strong>Email:</strong> {{ user.email }}</p>
        <p><strong>Telefon:</strong> {{ user.phone }}</p>
        <p><strong>Naslov:</strong> {{ user.address }}</p>

        <!-- Display List of Subscribed Organisations -->
        <div class="mt-3">
          <h4>Naročeni ste na:</h4>
          <ul>
            <li *ngFor="let organisation of user.organisations">
              {{ organisation.name }}
            </li>
          </ul>
        </div>

        <button class="btn btn-custom" (click)="toggleUserEditMode()">Uredi uporabniške podatke</button>
      </div>

      <!-- Edit User Information Form -->
      <form *ngIf="isUserEditMode" (ngSubmit)="saveUser()">
        <div class="form-group">
          <label for="username">Uporabniško ime:</label>
          <input type="text" class="form-control" id="username" [(ngModel)]="user.username" name="username">
        </div>
        <div class="form-group">
          <label for="email">Email:</label>
          <input type="email" class="form-control" id="email" [(ngModel)]="user.email" name="email">
        </div>
        <div class="form-group">
          <label for="phone">Telefon:</label>
          <input type="text" class="form-control" id="phone" [(ngModel)]="user.phone" name="phone">
        </div>
        <div class="form-group">
          <label for="address">Naslov:</label>
          <input type="text" class="form-control" id="address" [(ngModel)]="user.address" name="address">
        </div>
        
        <!-- Organisation Selection -->
        <label class="ms-4 mt-3 mb-2">Izberi organizacije za naročanje:</label>
        <div class="ms-4">
          <div *ngFor="let organisation of allOrganisations" class="form-check">
            <input 
              class="form-check-input"
              type="checkbox"
              [value]="organisation.organisationID"
              (change)="onOrganisationSelected(organisation.organisationID, $event)"
              [checked]="getSelectedOrganisationIds().includes(organisation.organisationID)"
              id="organisation-{{organisation.organisationID}}">
            <label class="form-check-label" for="organisation-{{organisation.organisationID}}">
              {{ organisation.name }}
            </label>
          </div>
        </div>

        <button type="button" class="btn btn-custom" (click)="saveUser()">Shrani spremembe</button>
        <button type="button" class="btn btn-custom-danger" (click)="toggleUserEditMode()">Prekliči</button>
      </form>
    </div>
  </div>
</div>
